import React, { useState } from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import googleOAuthService from './googleOAuthService.js';
import { loginWithGoogle } from './apiClient.js';

interface GoogleLoginButtonProps {
  onSuccess: (result: any, userProfile?: any) => void;
  onError: (error: Error) => void;
  isLoading?: boolean;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({
  onSuccess,
  onError,
  isLoading = false
}) => {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    setIsGoogleLoading(true);
    try {
      // Parse the credential response to get user data
      const userProfile = googleOAuthService.parseCredentialResponse(credentialResponse);
      
      // Call backend login API
      const result = await loginWithGoogle(userProfile);
      
      // Pass both result and userProfile to parent
      onSuccess(result, userProfile);
    } catch (error) {
      console.error('Google login error:', error);
      onError(error as Error);
    } finally {
      setIsGoogleLoading(false);
    }
  };

  const handleGoogleError = () => {
    console.error('Google login error');
    onError(new Error('Failed to authenticate with Google. Please try again.'));
  };

  return (
    <div className="">
      {isGoogleLoading ? (
        <button
          type="button"
          
          className="btn btn-outline-danger btn-lg w-100 d-flex align-items-center justify-content-center"
          disabled
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            borderRadius: '8px',
            border: '2px solid #dc3545',
            backgroundColor: 'transparent'
          }}
        >
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          Signing in with Google...
        </button>
      ) : (
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          useOneTap={false}
          auto_select={false}
          theme="outline"
          size="large"
          text="signin_with"
          shape="rectangular"
          width="100%"
        />
      )}
    </div>
  );
};

export default GoogleLoginButton;